const categoryBadgeClasses: Record<string, string> = {
  H: 'bg-orange-100 text-orange-800 border-orange-200 dark:bg-orange-950 dark:text-orange-300 dark:border-orange-900',
  W: 'bg-yellow-100 text-yellow-800 border-yellow-200 dark:bg-yellow-950 dark:text-yellow-300 dark:border-yellow-900',
  B: 'bg-purple-100 text-purple-800 border-purple-200 dark:bg-purple-950 dark:text-purple-300 dark:border-purple-900',
  A: 'bg-green-100 text-green-800 border-green-200 dark:bg-green-950 dark:text-green-300 dark:border-green-900',
  F: 'bg-red-100 text-red-800 border-red-200 dark:bg-red-950 dark:text-red-300 dark:border-red-900',
  N: 'bg-gray-100 text-gray-800 border-gray-200 dark:bg-gray-950 dark:text-gray-300 dark:border-gray-900',
}

export function getCategoryBadgeClass(code: string): string {
  return Object.hasOwn(categoryBadgeClasses, code) ? categoryBadgeClasses[code] : ''
}

const categoryLabels: Record<string, string> = {
  H: 'Honey',
  W: 'Wax',
  B: 'Beverages',
  A: 'Art',
  F: 'Food',
  N: 'Novice',
}

export function getCategoryLabel(code: string, fallback = code): string {
  return Object.hasOwn(categoryLabels, code) ? categoryLabels[code] : fallback
}

// Category order and chart fills shared by every category chart, so a category keeps its place and colour.
export const CATEGORY_ORDER = ['H', 'W', 'A', 'B', 'F', 'N']
const categoryChartTokens: Record<string, string> = {
  H: 'honey',
  W: 'wax',
  A: 'art',
  B: 'beverages',
  F: 'food',
  N: 'novice',
}

export function getCategoryChartColor(code: string): string {
  return `var(--class-chart-${Object.hasOwn(categoryChartTokens, code) ? categoryChartTokens[code] : 'other'})`
}

const categoryRowClasses: Record<string, string> = {
  H: 'bg-orange-50 dark:bg-orange-950',
  W: 'bg-yellow-50 dark:bg-yellow-950',
  B: 'bg-purple-50 dark:bg-purple-950',
  A: 'bg-green-50 dark:bg-green-950',
  F: 'bg-red-50 dark:bg-red-950',
  N: 'bg-gray-50 dark:bg-gray-950',
}

export function getCategoryRowClass(code: string): string {
  return Object.hasOwn(categoryRowClasses, code) ? categoryRowClasses[code] : ''
}

export function resolveCategoryCode(
  categoryCode: string | null | undefined,
  divisionCode: string
): string {
  return categoryCode ?? divisionCode
}
